// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JA0e","rootMobile":"styles_rootMobile__2yadt"};